export default {
    methods: {
        getSourceStateText(state){
            switch (state){
                case 'READY':
                    return this.$gettext('Připraveno');
                case 'WAITING':
                    return this.$gettext('Čeká na vyřízení');
                case 'FAILED':
                    return this.$gettext('Chyba');
            }
        },
        getLocalStateText(state){
            switch (state){
                case 'PENDING':
                    return this.$gettext('Čeká na vyřízení');
                case 'IMPORTED':
                    return this.$gettext('Připraveno');
                case 'FAILED':
                    return this.$gettext('Chyba');
                case 'UNUSED':
                    return this.$gettext('Nepoužívá se');
            }
        }

    }
}


// WEBPACK FOOTER //
// ./src/components/views/vodVideos/mixins/vodVideo.js